import { render } from "./Sprints.vue?vue&type=template&id=1bc27dea&scoped=true"
import script from "./Sprints.vue?vue&type=script&lang=js"
export * from "./Sprints.vue?vue&type=script&lang=js"

import "./Sprints.vue?vue&type=style&index=0&id=1bc27dea&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1bc27dea"

export default script